import React, { useContext, useRef } from 'react'
import { AiOutlineLogin } from 'react-icons/ai'
import { BsFillPersonFill } from 'react-icons/bs'
import { HiKey } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AuthContext } from '../../../context/Auth/AuthContext'
import { ButtonSubmit } from '../../../GlobalStyle'
import InputComponent from '../../components/Input'
import PasswordInput from '../../components/PasswordInput'
import BaseLogin from '../index'
import { IconInput, Infos, InputContainer, NewPassword, NewUser, TextUser } from '../style'

const Login = () => {
  const navigate = useNavigate()

  const isValiEmail = (val) => {
    return /\S+@\S+\.\S+/.test(val)
  }

  const auth = useContext(AuthContext)
  const ref = useRef()
  const handleLogin = async (e) => {
    e.preventDefault()

    const login = ref.current

    const email = login.name.value
    const password = login.password.value
    try {
      if (!email || !password) {
        throw Error('Preencha os campos')
      }
      if (!isValiEmail(email)) {
        throw Error('Formato de email inválido')
      }
      const isLogged = await auth.signIn(email, password)

      if (isLogged) {
        navigate('/')
      } else {
        throw new Error('Usuário não homologado')
      }
    } catch (e) {
      if (e.message === 'Usuário não homologado') {
        toast.error(e.message)
      } else {
        toast.warn(e.message)
      }
    }
  }
  return (
    <BaseLogin onSubmit={handleLogin} ref={ref}>
      <Infos>
        <AiOutlineLogin />
        <h2>Login</h2>
        <p>Digite suas credenciais para continuar</p>
      </Infos>

      <InputContainer>
        <IconInput>
          <BsFillPersonFill />
        </IconInput>

        <InputComponent login={'login'} name="name" placeholder="Email" />
      </InputContainer>
      <InputContainer>
        <IconInput>
          <HiKey />
        </IconInput>
        <PasswordInput login={'login'} placeholder="Senha" />
      </InputContainer>
      <NewPassword onClick={() => navigate('/login/recover')}>
        <TextUser>Recuperar senha</TextUser>
      </NewPassword>

      <NewUser>
        <ButtonSubmit type="submit">Entrar</ButtonSubmit>
      </NewUser>
    </BaseLogin>
  )
}

export default Login
